import React from "react"
import { useNavigate } from "react-router-dom"
import { Footer } from "../../components/Sections"
export default function Home() {
	const navigate = useNavigate()

	const handleResponse = (route) => {
		navigate(route)
	}

	return (
		<div>
			<div className="simple-form-container">
				<div className="simple-form-buttons">
					<button className="simple-form-button" onClick={() => handleResponse("/urgences")}>
						1 - Je viens d’être équipé je donne mes infos
					</button>
					<button className="simple-form-button" onClick={() => handleResponse("/commande")}>
						2 - Je souhaite passer une commande pour une attelle, etc ...
					</button>
					<button className="simple-form-button" onClick={() => handleResponse("/biovelox")}>
						3 - Commander Biolevox™ - Acide Hyaluronique
					</button>
					<button className="simple-form-button" onClick={() => handleResponse("/cryotherapie")}>
						4 - Vous avez besoin de louer une machine de cryothérapie ?
					</button>
				</div>
			</div>
			<Footer />
		</div>
	)
}
